export const API_KEY = "3e19ce7b891447459477f5ef54207823";
export const LIMIT = 16;
export const COUNTRY = 'us'